import styled from 'styled-components'

export default (styled.span || styled.Text)`
  display: block;
  background-repeat: no-repeat;
  background-position: left center;
  margin: -5px 0;
  padding: 5px 0;
`
